import { render, staticRenderFns } from "./TruckList.vue?vue&type=template&id=4b27c74a&scoped=true"
import script from "./TruckList.vue?vue&type=script&lang=js"
export * from "./TruckList.vue?vue&type=script&lang=js"
import style0 from "./TruckList.vue?vue&type=style&index=0&id=4b27c74a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b27c74a",
  null
  
)

export default component.exports